import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { fetchLoadVideoGallery } from 'components/common/BannerVideo/VideoGallery/fetchLoadVideoGallery';

import { addMagritteNotification } from 'store/models/notification';
import { removeVideoFromGallery } from 'store/models/videoGallery';
import { AppThunkAction } from 'store/utils';

type FetchDeleteVideoFromGallery = (videoUploadId: string) => AppThunkAction<void>;

export const fetchDeleteVideoFromGallery: FetchDeleteVideoFromGallery = (videoUploadId) => {
    return (dispatch) => {
        dispatch(removeVideoFromGallery(videoUploadId));

        void fetcher.delete(`/api/v1/videos/gallery?videoUploadId=${videoUploadId}`).catch(() => {
            dispatch(addMagritteNotification(MagritteNotificationName.SomethingWentWrong));
            dispatch(fetchLoadVideoGallery());
        });
    };
};
